// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M12 23A7.5 7.5 0 0 1 6.86 10.04C8.2 8.77 11.5 6.5 11 1.5 17 5.5 20 9.5 14 15.5 15 15.5 16.5 15.5 19 13.03 19.27 13.8 19.5 14.63 19.5 15.5A7.5 7.5 0 0 1 12 23"/>';

/** Flame (rewards). */
const icon: IconData = {
  id: "flame",
  name: "Flame",
  category: "rewards",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path d="M12 23A7.5 7.5 0 0 0 19.5 15.5C19.5 14.63 19.27 13.8 19 13.03Q16.5 15.5 15.2 15.5C19.2 8.5 17 5.5 11 1.5 11.5 6.5 8.2 8.77 6.86 10.04A7.5 7.5 0 0 0 12 23M12.71 5.23C15.95 7.98 15.97 10.12 13.46 14.5 12.7 15.83 13.66 17.49 15.2 17.49 15.89 17.49 16.58 17.29 17.32 16.9A5.5 5.5 0 1 1 8.23 11.49C8.36 11.37 9 10.8 9.02 10.78 9.44 10.4 9.79 10.06 10.14 9.69 11.37 8.37 12.25 6.91 12.71 5.23"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M13.07 2.96L14.75 4.39 15.44 5.11 16.02 5.84 16.49 6.59 16.85 7.38 17.09 8.19 17.21 9.05V9.96L17.07 10.92 16.81 11.95 16.41 13.05 15.88 14.23 15.2 15.5 15.93 15.35 16.8 14.88 17.82 14.11 19 13.03 19.35 14.23 19.5 15.5 19.35 17.01 18.91 18.42 18.22 19.69 17.3 20.8 16.19 21.72 14.92 22.41 13.51 22.85 12 23 10.86 22.91 9.77 22.66 8.74 22.25 7.79 21.7 6.92 21.02 6.17 20.21 5.53 19.29 5.03 18.27 4.69 17.18 4.52 16.07V14.96L4.68 13.87 5 12.81 5.47 11.81 6.09 10.88 6.86 10.04 8.14 8.87 8.89 8.1 9.62 7.17 10.26 6.07 10.75 4.76 11.02 3.25 11.05 2.41 11 1.5Z"/></g><path d="M12 23A7.5 7.5 0 0 0 19.5 15.5C19.5 14.63 19.27 13.8 19 13.03Q16.5 15.5 15.2 15.5C19.2 8.5 17 5.5 11 1.5 11.5 6.5 8.2 8.77 6.86 10.04A7.5 7.5 0 0 0 12 23M12.71 5.23C15.95 7.98 15.97 10.12 13.46 14.5 12.7 15.83 13.66 17.49 15.2 17.49 15.89 17.49 16.58 17.29 17.32 16.9A5.5 5.5 0 1 1 8.23 11.49C8.36 11.37 9 10.8 9.02 10.78 9.44 10.4 9.79 10.06 10.14 9.69 11.37 8.37 12.25 6.91 12.71 5.23"/>',
    },
  },
  animation: () => import("../animations/flame.js"),
};

export default icon;
